import { VFC, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Q_MAX_VALUES, Qmax } from '@enmon/commons';
import { Select } from '../../Select';
import { MeterDetails as messages } from '../../../Form/meter_details/messages';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface QMaxProps {
  value?: Qmax;
  onChange?: (value: Qmax) => void;
}

export const QMaxSelect: VFC<QMaxProps> = ({ ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const qMaxOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Q_MAX_VALUES,
        suggestedValue: meterModelSuggestions?.qMax?.value,
        suggestedSelection: meterModelSuggestions?.qMax?.selection,
      }),
    [intl, meterModelSuggestions],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={qMaxOptions}
      placeholder={<FormattedMessage {...messages.qMaxPlaceholder} />}
      suffix={`m${String.fromCharCode(179)}/h`}
      {...restProps}
    />
  );
};
